export const avatarErrorMessage = (page: number) => {
  if (page < 12) {
    return (
      'Effectue ' +
      (page < 6 ? '5' : page < 9 ? '15' : '50') +
      ' ventes pour débloquer la série ' +
      (page < 6 ? 'bronze' : page < 9 ? 'argent' : 'or')
    );
  } else {
    return "Tu dois atteindre une moyenne générale d'au moins 10 pour débloquer la série Halloween";
  }
};
